import { isSafariUserAgent } from 'utilities/browser';

import cleanupCartPrintContent from './cleanupCartPrintContent';

function waitForImagesToLoad (imgs) {

	const promises = [];
	[ ...imgs ]
		.filter((img) => !img.complete)
		.forEach((img) => {

			promises.push(
				new Promise((resolve, reject) => {

					img.addEventListener('load', resolve);
					img.addEventListener('error', reject);

				})
			);

		});

	return Promise.allSettled(promises);

}

function showPrintDialog () {

	window.print();

	// If on safari, after printing once we don't want to auto-close the modal.
	// This is b/c safari pops up a modal after 1st print saying automatic printing has been blocked.
	// This results in the lpModal already being auto-closed by the time you click "Allow", prints blank.
	if (!isSafariUserAgent()) {

		setTimeout(() => $('body').lpModalClose(), 50);

	}

}

function printCartContent (e) {

	e.preventDefault();

	cleanupCartPrintContent();
	document.body.classList.add('printMode');

	const printContainer = document.getElementById('printCartContainer');

	// Created temporary element to hold modal content outside since window.print() skips the non-viewport modal content
	const tempDiv = document.createElement('div');
	tempDiv.id = 'printSection';
	tempDiv.appendChild(printContainer.cloneNode(true));
	document.body.appendChild(tempDiv);

	// Since we just appended the print content, we need to wait for images to completely load before printing
	waitForImagesToLoad(document.querySelectorAll('#printSection img')).then(showPrintDialog);

}

export default printCartContent;
